<template>
  <v-chart class="line1" :option="option" />
</template>

<script>
import { getUserDateView } from "@/api/comd.js";
export default {
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["新增用户", "在线活跃数"],
          left: 10,
          top: 10,
          textStyle: {
            color: "#fff",
          },
          icon: "rect",
        },
        xAxis: [
          {
            type: "category",
            data: ["7/1", "7/2", "7/3", "7/4", "7/5", "7/6", "7/7"],
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value} ",
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "",
            min: 0,
            max: 4,
            interval: 1,
            axisLabel: {
              formatter: "{value}万",
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                opacity: 0.3,
              },
            },
          },
        ],
        series: [
          {
            name: "新增用户",
            type: "bar",
            barWidth: 10,
            /*设置柱状图颜色*/
            itemStyle: {
              normal: {
                symbol: "roundRect",
                barBorderRadius: 30,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#37BBF8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#3977E6", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
                /*信息显示方式*/
                label: {
                  // show: true,
                  position: "top",
                  formatter: "{b}\n{c}",
                },
              },
            },
            data: [50, 75, 100, 150, 200, 250, 150],
          },
          {
            name: "在线活跃数",
            type: "line",
            smooth: true,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#3CE68B", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff0", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              /*设置折线颜色*/
              normal: {
                color: "#3CE68B",
              },
            },
            data: [30, 175, 150, 60, 10, 20, 50],
          },
        ],
      },
      dataViewCp: [],
    };
  },
  created() {

  },
  mounted(){
    this.getUserDateViewHandel();

  },
  methods: {
    async getUserDateViewHandel() {
      let res = await getUserDateView();
      this.dataViewCp = res.data;
      this.option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["新增用户", "在线活跃数"],
          left: 10,
          top: 10,
          textStyle: {
            color: "#fff",
          },
          icon: "rect",
        },
        xAxis: [
          {
            type: "category",
            data: this.dataViewCp.map((en) => en.dateValue),
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: "{value} ",
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "",
            min: 0,
            max: 4,
            interval: 1,
            axisLabel: {
              formatter: "{value}万",
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                opacity: 0.3,
              },
            },
          },
        ],
        series: [
          {
            name: "新增用户",
            type: "bar",
            barWidth: 10,
            /*设置柱状图颜色*/
            itemStyle: {
              normal: {
                symbol: "roundRect",
                barBorderRadius: 30,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#37BBF8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#3977E6", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
                /*信息显示方式*/
                label: {
                  // show: true,
                  position: "top",
                  formatter: "{b}\n{c}",
                },
              },
            },
            data: this.dataViewCp.map((en) => en.newAddUser),
          },
          {
            name: "在线活跃数",
            type: "line",
            smooth: true,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#3CE68B", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff0", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              /*设置折线颜色*/
              normal: {
                color: "#3CE68B",
              },
            },
            data: this.dataViewCp.map((en) => en.activeUser),
          },
        ],
      };
    },
  },
};
</script>

<style>
</style>